var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppicon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7516 0C28.5665 0 30.4735 0 32.5271 0.649167C34.7691 1.46522 36.5348 3.23095 37.3508 5.47295C38 7.52622 38 9.43382 38 13.2484V24.7516C38 28.5665 38 30.4735 37.3508 32.5271C36.5348 34.7691 34.7691 36.5348 32.5271 37.3505C30.4735 38 28.5665 38 24.7516 38H13.2484C9.4335 38 7.52622 38 5.47295 37.3505C3.23095 36.5348 1.46522 34.7691 0.649167 32.5271C0 30.4735 0 28.5665 0 24.7516V13.2484C0 9.43382 0 7.52622 0.649167 5.47295C1.46522 3.23095 3.23095 1.46522 5.47295 0.649167C7.52622 0 9.4335 0 13.2484 0H24.7516Z",
    fill: "url(#paint0_linear_2037_7272)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.0228 25.7933L11.2266 19.1914H19.2705L23.0291 25.8184L15.0228 25.7933Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5659 25.762L23.0299 25.8185L15.3496 12.2761L19.0894 5.80273L30.5659 25.762Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9887 30.9501H10.4871L7.49023 25.6648L11.2269 19.1914L17.9887 30.9501Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2037_7272",
    x1: -1.49699e-7,
    y1: 3.20809,
    x2: 8.842,
    y2: 45.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4675FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05D6B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppicon5);
export default __webpack_public_path__ + "static/media/appicon5.ab5607ebfd64ec148033a0792f8f1372.svg";
export { ForwardRef as ReactComponent };